export const brandName = '黑料学生';

export const navLinks = [
  { label: '热度榜', href: '#ranking' },
  { label: '最新澄清', href: '#latest' },
  { label: '反转时间线', href: '#timeline' },
  { label: '当事人回应', href: '#responses' },
  { label: '专题合集', href: '#collections' },
  { label: '求证指南', href: '#guide' },
];

export const heroStats = [
  { value: '1,286', label: '已归档澄清条目' },
  { value: '93.4%', label: '附完整时间线' },
  { value: '48h', label: '热点平均复核时长' },
  { value: '327', label: '本周新增专题' },
];

export const heroTags = [
  '黑料学生澄清',
  '黑料学生辟谣',
  '黑料学生反转',
  '黑料学生真相',
  '当事人回应',
  '洗白 or 实锤',
];

export const tickerItems = [
  '图书馆占座冲突 · 监控时间线已公开',
  '社团纳新收费 · 收支明细全量披露',
  '食堂异物图片 · 原始拍摄时间早于本轮讨论',
  '奖学金名单 · 官方复核为脱敏公示版本',
  '校园卡扣费 · 跨校区结算延迟已补回',
  '宿舍合照争议 · 拍摄花絮与时间戳可对应',
];

export const hotRanking = [
  {
    rank: '01',
    title: '网传「图书馆刷夜占座」冲突视频',
    summary: '完整监控与双方聊天记录公开后，谁先动手的关键节点出现反转。',
    heat: '18.6万',
    bar: 100,
    tag: '反转',
    status: '复核中',
  },
  {
    rank: '02',
    title: '「社团纳新收费」传闻持续发酵',
    summary: '负责学生晒出全部收支明细，结余款项已原路退回并公示凭证。',
    heat: '15.2万',
    bar: 84,
    tag: '已澄清',
    status: '已澄清',
  },
  {
    rank: '03',
    title: '「食堂异物」图片二次传播',
    summary: '原始拍摄时间早于本轮讨论，检测报告显示为餐后残留物。',
    heat: '13.7万',
    bar: 76,
    tag: '辟谣',
    status: '已澄清',
  },
  {
    rank: '04',
    title: '「奖学金名单泄露」截图流言',
    summary: '官方复核说明名单为公示期脱敏版本，未涉及任何隐私字段。',
    heat: '11.4万',
    bar: 63,
    tag: '回应',
    status: '复核中',
  },
  {
    rank: '05',
    title: '「校园卡无故扣费」群聊记录',
    summary: '实为跨校区结算延迟，次日全部补回并附带逐笔明细。',
    heat: '9.8万',
    bar: 54,
    tag: '真相',
    status: '已澄清',
  },
  {
    rank: '06',
    title: '「宿舍合照被指摆拍」争议',
    summary: '完整拍摄花絮流出，机位与时间戳可对应，质疑点已逐条回应。',
    heat: '8.1万',
    bar: 45,
    tag: '反转',
    status: '反转中',
  },
];

export const latestCases = [
  {
    date: '09-10',
    tag: '已澄清',
    title: '「社团纳新收费」账目全公开，结余已原路退回',
    summary:
      '当事人上传完整收支表与退款截图，逐笔说明费用去向，此前流传的「中饱私囊」说法不成立。',
  },
  {
    date: '09-09',
    tag: '反转',
    title: '图书馆占座冲突：先动手时间点被监控更正',
    summary:
      '初版流传的剪辑视频省去前 40 秒，完整监控显示双方均有推搡，「单方面施暴」结论被推翻。',
  },
  {
    date: '09-08',
    tag: '辟谣',
    title: '食堂异物图片实为餐后拍摄，非出餐环节问题',
    summary:
      '比对原图 EXIF 时间与就餐记录，图片拍摄于用餐结束后，与后厨加工流程无直接关联。',
  },
  {
    date: '09-07',
    tag: '回应',
    title: '奖学金名单为脱敏公示版本，未泄露隐私字段',
    summary:
      '校方复核后说明公示模板已做脱敏处理，网传截图中的「完整学号」实为旧版模板误传。',
  },
  {
    date: '09-06',
    tag: '澄清',
    title: '校园卡扣费系跨校区结算延迟，次日全部补回',
    summary:
      '后勤部门提供逐笔明细，确认扣款与消费记录一一对应，不存在重复扣费或资金挪用。',
  },
];

export const timelineSteps = [
  {
    time: '09-08 21:40',
    title: '首条短视频流出',
    desc: '一段 12 秒的剪辑视频在多个校园群转发，画面仅保留推搡瞬间。',
    state: '已证实',
    tone: 'neutral',
  },
  {
    time: '09-08 23:15',
    title: '话题进入热度榜前列',
    desc: '「单方面施暴」的说法开始扩散，评论区出现大量未经核实的指控。',
    state: '存疑',
    tone: 'warn',
  },
  {
    time: '09-09 10:02',
    title: '当事双方各自发声',
    desc: '两名当事人先后发布说明，对起因与先动手顺序的描述存在明显冲突。',
    state: '待核',
    tone: 'neutral',
  },
  {
    time: '09-09 16:30',
    title: '完整监控公开',
    desc: '补充前 40 秒画面后可见，争执由座位归属口角升级，双方均有推搡动作。',
    state: '反转',
    tone: 'flip',
  },
  {
    time: '09-10 09:20',
    title: '校方通报与处理结果',
    desc: '依据完整监控与证人笔录给出说明，双方均接受调解，原「施暴」说法不成立。',
    state: '已澄清',
    tone: 'ok',
  },
];

export const responses = [
  {
    role: '当事学生 · 一方',
    handle: '匿名说明',
    content:
      '座位是我先到的，但推人这件事我确实做了，前面被剪掉的那段口角才是我情绪失控的原因。',
    time: '09-09 10:02',
  },
  {
    role: '当事学生 · 另一方',
    handle: '匿名说明',
    content:
      '我承认我也有推回去的动作。希望大家看完完整视频再判断，不要把我说成完全无辜的一方。',
    time: '09-09 11:36',
  },
  {
    role: '校方 · 学生工作处',
    handle: '官方通报',
    content:
      '经调取完整监控与证人笔录，双方均存在推搡行为，已按校纪调解处理，网传「单方面施暴」不属实。',
    time: '09-10 09:20',
  },
];

export const verdicts = [
  {
    title: '「单方面施暴」的说法',
    verdict: '实锤不成立',
    tone: 'flip',
    reason: '完整监控显示双方均有推搡动作，剪辑视频省略了起因片段。',
    evidence: '完整监控 · 证人笔录',
  },
  {
    title: '「社团纳新暗中收费」的说法',
    verdict: '实锤不成立',
    tone: 'flip',
    reason: '收支明细与退款凭证齐全，费用去向逐笔可核对。',
    evidence: '收支表 · 退款截图',
  },
  {
    title: '「食堂异物来自后厨」的说法',
    verdict: '暂无实锤',
    tone: 'pending',
    reason: '图片拍摄时间晚于用餐结束，尚无证据指向加工环节。',
    evidence: '原图时间戳 · 检测报告',
  },
  {
    title: '「扣费记录被篡改」的说法',
    verdict: '实锤不成立',
    tone: 'flip',
    reason: '扣款与消费逐笔对应，差异来自跨校区结算延迟。',
    evidence: '账单明细 · 系统日志',
  },
];

export const collections = [
  {
    title: '开学季传闻澄清合集',
    desc: '纳新、收费、社团账目类传言，一次看清哪些已澄清、哪些仍在复核。',
    count: '18 篇',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20campus%20notebooks%20and%20folders%20on%20a%20cream%20desk%20with%20soft%20morning%20light%2C%20muted%20terracotta%20and%20ochre%20tones%2C%20clean%20minimal%20composition%2C%20magazine%20still%20life%20photography%2C%20high%20detail%2C%20no%20text&width=900&height=700&seq=hls-coll-01&orientation=landscape',
  },
  {
    title: '截图鉴定 · 流传图盘点',
    desc: 'EXIF、时间戳、像素比对，逐张拆解被反复转发的网传截图。',
    count: '24 篇',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20blurred%20printed%20screenshots%20scattered%20on%20a%20warm%20beige%20surface%20with%20a%20magnifier%2C%20soft%20afternoon%20light%2C%20muted%20clay%20and%20amber%20palette%2C%20editorial%20still%20life%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=900&height=700&seq=hls-coll-02&orientation=landscape',
  },
  {
    title: '当事人回应全记录',
    desc: '按发布时间排序的回应原文与后续补充说明，避免断章取义。',
    count: '31 篇',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20scene%20of%20an%20open%20notebook%20and%20pen%20beside%20a%20ceramic%20cup%20on%20a%20cream%20table%2C%20soft%20window%20light%2C%20muted%20sage%20and%20terracotta%20accents%2C%20calm%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=900&height=700&seq=hls-coll-03&orientation=landscape',
  },
  {
    title: '反转复盘 · 时间线档案',
    desc: '把每一个反转节点按小时铺开，看清结论是在哪一步被改写的。',
    count: '16 篇',
    image:
      'https://readdy.ai/api/search-image?query=Stacked%20paper%20timeline%20cards%20with%20wooden%20clips%20on%20a%20warm%20linen%20background%2C%20soft%20diffused%20light%2C%20muted%20ochre%20and%20clay%20tones%2C%20minimal%20editorial%20flat%20lay%2C%20clean%20harmonious%20composition%2C%20no%20text&width=900&height=700&seq=hls-coll-04&orientation=landscape',
  },
];

export const guides = [
  {
    step: '01',
    icon: 'ri-time-line',
    title: '先看时间，再看结论',
    desc: '任何流传内容先确认发布与拍摄时间，时间对不上的截图，结论往往也站不住。',
  },
  {
    step: '02',
    icon: 'ri-file-search-line',
    title: '找原始出处，而非转发',
    desc: '顺着转发链回溯到最初发布者，二手转述最容易在复述中改变语气与事实。',
  },
  {
    step: '03',
    icon: 'ri-scissors-cut-line',
    title: '警惕被剪辑的片段',
    desc: '只保留了冲突瞬间的视频，通常省略了起因，先问一句「前后 30 秒去哪了」。',
  },
  {
    step: '04',
    icon: 'ri-scales-3-line',
    title: '分清澄清与洗白',
    desc: '澄清是拿出可核对的证据，洗白是只讲情绪不给材料，看证据不看立场。',
  },
];